module.exports = __webpack_public_path__ + "img/Taco-Birria.07ab508c.jpg";